
export default [

        {
            path:'/market_data',
            name:'market_data',
            component:() => import('@/views/market_data/market_data'),
            meta: {

                keepAlive: true, //此组件需要被缓存
                isBack:false,
      
            }
        },
        
]


// WEBPACK FOOTER //
// ./src/router/market_data.js